import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { GetPasscodeListMembers } from '@/connection/audiences/passcode-lists';

export const fetchPasscodeListMembers = (create: ReducerCreators<AudiencesState>) =>
  create.asyncThunk(
    async ({ passcodeListId, offset, order }: { passcodeListId: number; offset: number; order: number }) => {
      const passcodeListMembers = await GetPasscodeListMembers(passcodeListId, offset, order);
      return passcodeListMembers;
    },
    {
      fulfilled: (state, action) => {
        if (action.payload) {
          state.passcodeListMembers = action.payload || [];
        }
        state.loadingPasscodeListMembers = false;
      },
      pending: (state) => {
        state.loadingPasscodeListMembers = true;
      },
      rejected: (state, action) => {
        state.loadingPasscodeListMembers = false;
        console.error(action.error);
      },
    }
  );
